import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import { Carousel } from "react-bootstrap";

const SummerCamp =()=>{
  return(
   <>
    
    <MenuBar />
    <Sidebar />
      {/* <!-- Page Banner Section --> */}
      <PageBanner title="Kids Spring Camp" />

      {/* <!--End Banner Section --> */}

      <div className="container">



        <div className="auto-container">

          <div className="centered">
            <hr />
            <h3> Kids Spring Camp </h3>
            <hr />
            <a href="https://schools.procareconnect.com/form/793b1010-056d-4e63-8ea7-56629da0d53d" target="_blank" className="alert alert-primary">
              <span className="btn-title"><span className="fa fa-2x fa fa-hand-o-right"></span>  Please click here for registration </span>
            </a>
            <hr />
          </div>
        </div>

        <div className="row">

          <div className="col-lg-12">
            <div className="card card-margin">
              <div className="card-header no-border">
                <h5 className="card-title"> Kids Spring Camp</h5>

              </div>
              <div className="card-body pt-0">
                <div className="widget-49">

                  <figure className="image">
                    <img src="https://yugalkunj.org/images/kids_spring_Camp.jpeg" alt="" style={{ width: "100%" }} />
                    <a href="https://yugalkunj.org/images/kids_spring_Camp.jpeg" className="lightbox-image overlay" data-fancybox="gallery-two"></a>
                  </figure>
                  <br />
                  <div className="widget-49-meeting-action">
                    <a href="https://yugalkunj.org/images/kids_spring_Camp.jpeg" target="_blank" className="btn btn-sm btn-flash-border-primary">View Flyer</a>
                  </div>

                </div>
              </div>
            </div>
          </div>


        </div>



      </div>


      <hr />
         <section className="coming-events">

          <div className="auto-container">
            <div className="sec-title centered">

              <h2>  Kids Spring Camp Schedules and Menu </h2>

            </div>

            <Carousel variant="dark">

            <Carousel.Item className="active">
                <img
                  className="d-block w-100"
                  src="https://yugalkunj.org/images/spring-camp-shedule.png"
                  alt="Kids Spring Camp"
                  style={{ width: "100%" }}
                />

              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://yugalkunj.org/images/spring-camp-menu.jpeg"
                  alt="Kids Spring Camp"
                  style={{ width: "100%" }}
                />


              </Carousel.Item>
           

            </Carousel>



          </div>
        </section> 
      <Footer />
   
   
   </>



  )

}

export default SummerCamp;
